import { lazyBg } from './lazyBg'

export const navigation = () => {
  const loaded = {
    mobile: false,
    desktop: false
  }

  const resizeHandler = async () => {
    if(document.querySelector('header').id !== 'canada'){
      let menuRoute = ''
      if(!window.matchMedia('(min-width: 1024px)').matches && !loaded.mobile){
        menuRoute = '/static/menu/mobile/'
        loaded.mobile = true
      }else if(window.matchMedia('(min-width: 1024px)').matches && !loaded.desktop){
        menuRoute = '/static/menu/desktop/'
        loaded.desktop = true
      }else{
        return false
      }
  
      const res = await fetch(menuRoute, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      const data = await res.text()
      document.querySelector('header>.container').insertAdjacentHTML('beforeend', data)
      lazyBg()
    }
  }


  window.addEventListener('resize', resizeHandler)
  resizeHandler()
}